import localforage from 'localforage';

localforage.config({
    driver: [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE],
    name: 'DigiFarmInput',
    storeName: 'df-input-webapp',
    description: 'Client db for DigiFarm Input',
});
export { localforage as storage };
